import React from "react";
import xss from "xss";
import { connect } from "react-redux";

import { Link, useMatch, useNavigate } from "../utils/components/router";
import PageHeader from "./PageHeader";
import KundeLogin from "./KundeLogin";
import KundenFormMA from "./KundenFormMA";
import { kundenActions } from "../actions";
import { PERSONART, RAGE_RIGHT } from "../utils/enums";
import { checkResize, console, isAuthenticated, sendError } from "../utils/functions";
import CONFIG from "../config";
import { ErrorMessage } from "./components";
import Error from "../pages/Error";
// import mandantStorage from "../storage/mandant-storage";

class KundenEditMA extends React.Component {
  state = {
    kunde: this.props.kundenStorage.kunde,
    updateError: null,
    error: null
  };

  componentDidMount() {
    checkResize();
    let kunde = this.props.kundenStorage.kunde;
    this.setState({ kunde: kunde });

    // if (!mandantStorage.abwAdresseBsErlaubt()) {
    //   this.props.navigate(`${CONFIG.LINK_KUNDEN_ADDRESSE_MA}${xss(this.props.params.id)}`);
    // }
  }

  onSubmit = async formValues => {
    // Hier müssen AxiosCalls angepasst werden
    const { params, kundenStorage, configStorage, basketStorage, mandantStorage, dispatch, navigate } = this.props;
    if (params.id === undefined && kundenStorage.kunde !== null) {
      params.id = kundenStorage.kunde.id || kundenStorage.kundenId;
    }
    delete formValues.email2;
    if (formValues.personArt === PERSONART.JURISTISCHE_PERSON.KUERZEL) {
      formValues.vorname = "";
    }
    let requestDataKundenEntry = configStorage.getRequestData("kunde", "patch", { kunde: formValues });
    requestDataKundenEntry.url = requestDataKundenEntry.url + xss(params.id);
    const kunde = await dispatch(kundenActions.editEntry(requestDataKundenEntry))
      .catch(err => {
        console.error("KundenEditMA submit", err);
        sendError(err, "KundenEditMA");
        this.setState({ updateError: err });
      });
    if (kunde) {
      let requestDataKundenEntryFetch = configStorage.getRequestData("kunde");
      let success = true;
      if (configStorage.isMaShop()) {
        success &= !!await dispatch(kundenActions.fetchEntries(requestDataKundenEntryFetch))
          .catch(err => {
            console.error("KundenEditMA submit", err);
            sendError(err, "KundenEditMA");
            this.setState({ error: err });
          });
      }
      requestDataKundenEntryFetch.url = requestDataKundenEntry.url;
      success &= !!await dispatch(kundenActions.fetchEntry(requestDataKundenEntryFetch))
        .catch(err => {
          console.error("KundenEditMA submit", err);
          sendError(err, "KundenEditMA");
          this.setState({ error: err });
        });
      if (success) {
        if (
          (
            basketStorage.selectedFiliale !== null &&
            basketStorage.hasFilialChoice
          ) || (
            mandantStorage && !mandantStorage.lieferadresseIsEditable()
          )
        ) {
          navigate(CONFIG.LINK_FILIALELIEFERUNG);
        } else {
          navigate(`${CONFIG.LINK_KUNDEN_ADDRESSE_MA}${xss(params.id)}`);
        }
      }
    }
  };

  render() {
    if (!isAuthenticated(this.props)) {
      return (<KundeLogin></KundeLogin>);
    }
    if (!this.props.kundenStorage.kunde) return <Error messageText="Es sind keine Kundendaten vorhanden" />;
    return (
      <div id={CONFIG.SHOP_ID} className="if6_outer section if6_section full-height">
        <PageHeader showTimeout={true} />
        <section className="bootstrap-iso" aria-label="Kundendaten">
          <div className="container bg-white pt-one pb-one">
            <div className="row">
              <div className="col-12 col-md-10 offset-md-1">
                <ErrorMessage text="Beim Laden der Kundendaten ist ein Fehler aufgetreten:" error={this.state.error} />
                <div className="col-12 col align-self-center">
                  <h2 className="text-secondary">
                    Kundendaten aktualisieren
                  </h2>
                  <KundenFormMA
                    initialValues={{
                      vorname: this.props.kundenStorage.kunde.vorname ? this.props.kundenStorage.kunde.vorname : "",
                      nachname: this.props.kundenStorage.kunde.nachname,
                      kundenkonto: this.props.kundenStorage.kunde.kundenkonto,
                      strasse1: this.props.kundenStorage.kunde.strasse1,
                      strasse2: this.props.kundenStorage.kunde.strasse2,
                      plz: this.props.kundenStorage.kunde.plz,
                      ort: this.props.kundenStorage.kunde.ort,
                      nationalitaet: this.props.kundenStorage.kunde.nationalitaet,
                      gebietsansaessigKz: this.props.kundenStorage.kunde.gebietsansaessigKz,
                      personArt: this.props.kundenStorage.kunde.personArt,
                      gebDatKunde: this.props.kundenStorage.kunde.gebDatKunde,
                      gebOrtKunde: this.props.kundenStorage.kunde.gebOrtKunde,
                      email: this.props.kundenStorage.kunde.email,
                      email2: this.props.kundenStorage.kunde.email,
                      isMaShop: this.props.configStorage.isMaShop()
                    }}
                    edit={true}
                    onSubmit={this.onSubmit}
                  />
                  <ErrorMessage text="Beim Speichern ist ein Fehler aufgetreten:" error={this.state.updateError} />
                </div>
                <div className="col-12">
                  <Link
                    to={this.props.configStorage.getBackToShopLink()}
                    className="btn btn-info col-6 col-md-4 col-lg-2">
                    Zurück zum Shop
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
export default connect(store => {
  return {
    basketStorage: store.basketStorage,
    configStorage: store.configStorage,
    kundenStorage: store.kundenStorage,
    rightStorage: store.rightStorage,
    mandantStorage: store.mandantStorage,
    authenticationStorage: store.authenticationStorage,
    requiredRageRight: [RAGE_RIGHT.RAGE_BERATER_EINS, RAGE_RIGHT.RAGE_BERATER_ZWEI]
  };
})((props) => {
  const { params } = useMatch();
  const navigate = useNavigate();
  const contextNavigate = props.configStorage.contextNavigate(navigate);
  return <KundenEditMA params={params} navigate={contextNavigate} {...props} />;
});
